export const LOCAL_STORAGE_ACCESS_TOKEN = "alertadis:token";
export const LOCAL_STORAGE_SEARCHED_CAPTATIONS_POINTS = "alertadis-searched-captations-points";
export const LOCAL_STORAGE_SEARCHED_EFFLUENTS_POINTS = "alertadis-searched-effluents-points";
